var exports = {
  "vK": "ReportFlowBanner.module__banner___MTRLWl",
  "Kk": "ReportFlowBanner.module__icon___MTRLWl",
  "Qq": "ReportFlowBanner.module__text___MTRLWl",
};

module.exports = exports;
